<template>
  <div class="box tqm">
    <div class="box-head bg-color1 felx-between">
      <div class="box-head-title color1 flex-algin">督查督办统计</div>
      <!-- <el-button type="primary" class="bg-color2" @click="toInfo">验收</el-button> -->
    </div>
    <div class="box-table">
      <el-table
       stripe
        :data="tableList"
        height="100%"
        style="width: 100%;border:0;height:100%;"
        :header-cell-class-name="tableHeadCellName"
        :header-row-class-name="tableHeadRowName"
        :row-class-name="tableRowClassName"
      >
        <el-table-column prop="projectName" label="检查项目" align="center">
          <template slot-scope="scope">
            <p
              style="white-space: nowrap;text-overflow: ellipsis;overflow: hidden;"
              :title="scope.row.projectName"
            >{{scope.row.projectName}}</p>
          </template>
        </el-table-column>
        <el-table-column prop="supervisionItems" label="督办事项" align="center" width="250"></el-table-column>
        <el-table-column prop="disposeResult" label="督办结果" align="center" width="250"></el-table-column>
        <el-table-column label="督办时间" align="center" width="200">
          <template slot-scope="scope" v-if="scope.row.status=='1'">
            <span>{{scope.row.updateDate}}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" width="150">
          <template slot-scope="scope" v-if="scope.row.id">
            <el-button
              size="mini"
              type="danger"
              class="bg-color3"
              v-if="scope.row.status=='0'"
              @click="toinfo(scope.row)"
            >督办</el-button>
            <el-button size="mini" type="primary" class="bg-color5" v-else>已督办</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div style="width:100%;">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[5, 10, 20, 30, 50]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalItems"
        style="padding-top:10px;"
      ></el-pagination>
    </div>
  </div>
</template>
<script>
import myHttp from '../../untils/port'
import util from '../../untils/util'
export default {
  data() {
    return {
      tableList: [],
      tableHeadCellName: 'table-head-cell',
      tableHeadRowName: 'table-head-row',
      currentPage: 1,
      pageSize: 10,
      totalItems: 0,
      joinType:'',
    }
  },
  mounted() {
    this.groupId = this.$store.state.groupId
    this.joinType = util.session.get('roleId')=='3'?'3':'2'
    if ('' == this.groupId || undefined == this.groupId) {
      this.groupId = util.session.get('groupId')
    }
    this.getData()
  },
  methods: {
    handleSizeChange(val) {
      this.pageSize = val
      this.handleCurrentChange(this.currentPage)
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.currentChangePage()
    },
    // 监控当前页码
    currentChangePage(list) {
      this.getData()
    },
    //获取列表
    getData() {
      var that = this
      myHttp
        .findSupervisionList({
          entId: this.groupId,
          // entId:"1226358010507403265",
          loginPlatform: this.joinType,
          pageNum: this.currentPage,
          pageSize: this.pageSize
        })
        .then(function(resp) {
          if (resp.data.code == '200') {
            var list = resp.data.data.pageInfo.list || []
            var result = []
            for (var i = 0; i < list.length; i++) {
              list[i].index = (that.currentPage - 1) * that.pageSize + (i + 1)
              result.push(list[i])
              // result.push({})
            }
            that.tableList = result
            if (that.totalItems == 0) {
              that.totalItems = resp.data.data.pageInfo.total
            }
          }
        })
    },
    //
    tableRowClassName({ row, rowIndex }) {
      // if (rowIndex%2 === 0) {
      // return 'full-row';
      // } else if (rowIndex%2 === 1) {
      // return 'null-row';
      // }
      return 'full-row'
    },
    //跳转详情
    toinfo(row) {
      this.$router.push({ path: '/conpatrolInfo/' + row.id })
    }
  }
}
</script>
<style scoped>
* {
  box-sizing: border-box;
}
.box {
  width: 100%;
  position: relative;
  height: calc(100vh - 170px);
  background: #fff;
}
.box-head {
  width: 100%;
  height: 40px;
  position: relative;
  display: flex;
  padding: 0 20px;
}
.box-table {
  width: 100%;
  height: calc(100% - 90px);
  position: relative;
  /* overflow: auto; */
}
.el-table .box-head-title {
  font-size: 16px;
}

.flex-algin {
  display: flex;
  align-content: center;
  align-items: center;
}
.felx-between {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.bg-color1 {
  background: #fff;
}
.bg-color2 {
  background: #0d2dff;
}
.bg-color3 {
  background: #ffbc01;
}
.bg-color4 {
  background: #36c635;
}
.bg-color5 {
  background: #707070;
}
.color1 {
  color: #17b2fe;
}
</style>
<style>
.tqm .el-table .table-head-cell,
.tqm .table-head-row {
  background: #fff;
  color: #4c9aff;
  font-size: 18px;
  text-align: center;
}
.tqm .el-table .full-row {
  background: #fff !important;
  color: #6b6b6b;
  font-size: 18px;
  text-align: center;
}
.tqm .el-table .null-row {
  background: #f5f5f5 !important;
  border: 0;
  height: 10px;
}
.tqm .el-table .el-table__empty-block {
  background: #fff;
  color: #4c9aff;
  font-size: 18px;
  border: 0;
}
.tqm .el-table td,
.tqm .el-table th.is-leaf {
  border: 0;
  border-bottom: 1px solid #f5f5f5;
}
.tqm .el-table--enable-row-hover .el-table__body tr:hover > td,
.tqm .el-table,
.tqm .el-table__expanded-cell {
  background-color: inherit;
}
.tqm .el-pagination span {
  color: #fff;
}
</style>